export const HEADER_HEIGHT_CLASS = 'h-16'

export const PUBLIC_HEADER_SURFACE_CLASS =
  'bg-background-50/95 backdrop-blur-[12px]'

export const APP_HEADER_SURFACE_CLASS = 'bg-transparent'

export const HEADER_INNER_CLASS =
  'mx-auto flex h-full w-full max-w-[1280px] items-center justify-between px-5 md:px-8'
